import { getCustomerTemplate } from "@/lobby_common/api/basic_gen";
import Bus from "@/lobby_common/utils/bus.js";
import { isMobile } from "@/lobby_common/utils/utils.js";
import TelegramUtil from "@/lobby_common/utils/telegramUtil.js";
import { getBrandTemplate } from "@/lobby_common/api/basic_gen";
import { locationJump } from "@/lobby_common/utils/eventFunction.js";
import { getCacheData } from "@/lobby_common/utils/index";

export default {
  name: "ServiceChannel",
  components: {},
  data() {
    return {
      iframeDialog: false,
      customServiceConfig: {},
      lang: this.$store.getters.getLang,
      iconList: [],
      visible: false,
    };
  },
  computed: {
    getToken() {
      return this.$store.getters.taken;
    },
    getIsMobile() {
      return this.$store.getters.getIsMobile;
    },
    vipKefu() {
      const arr = this.customServiceConfig.list || [];
      const obj =
        arr.find((v) => {
          return v.type === "vip";
        }) || {};
      const content = JSON.parse(obj.content || "{}");
      return {
        ...content,
        type: obj.type || "",
      };
    },
  },
  async created() {
    const that = this;
    Bus.$off("goKehu");
    Bus.$on("goKehu", function () {
      that.kehubox();
    });
    const { code, data } = await this.getData();
    if (code !== 0) return;
    if (!data) return;
    this.iconList = data.socialPlatform || [];
    this.$store.commit("setBrandData", data);
  },
  mounted() {
    // this.$store.dispatch("getBrandData");
    this.customServiceConfigdata();
  },
  watch: {},
  methods: {
    async getData() {
      const brandTemplate = getCacheData("brand");
      if (brandTemplate) {
        return {
          code: 0,
          data: brandTemplate,
        };
      }
      return getBrandTemplate({});
    },
    onLink(item, eid) {
      this.$eventPost("click", {
        eid,
        homePageLink: item.homePageLink,
        time: Date.now(),
      });
      if (isMobile()) {
        TelegramUtil.hideBackButton();
        if (window?.Telegram?.WebApp?.openLink) {
          Telegram.WebApp.openLink(item.homePageLink);
        } else {
          // window.open(item.homePageLink, "_self");
          locationJump(item.homePageLink, 2);
        }
      } else {
        window.open(item.homePageLink, "_blank");
      }
    },
    // 客户消息
    customServiceConfigdata() {
      this.userdata = this.$store.getters.getPacketConfig?.packet_config;
      this.user = this.$store.getters?.user || {};
      getCustomerTemplate({}).then((res) => {
        if (res.code === 0) {
          // this.customServiceConfig = res.data.custom_service_config || {}
          this.customServiceConfig = res.data || {};
          // Bus.$emit("busGetEmail", this.customServiceConfig.email)
          this.$store.commit("setCustomerService", res.data);
          const saItem = res?.data?.list?.find(
            (item) => item.type === "sasalesmaty"
          );
          // console.log(saItem);
          if (saItem) {
            const content = JSON.parse(saItem.content);
            this.loadScript(content.url);
          }
        }
      });
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = () => resolve(true);
        script.onerror = () => reject(new Error("Script load failed"));
        document.head.appendChild(script);
      });
    },
    kehubox() {
      this.user = this.$store.getters?.user || {};
      let lang = "";
      if (this.lang === "pu") {
        lang = "pt-BR";
      } else if (this.lang === "en") {
        lang = "en-US";
      } else if (this.lang === "zh" || this.lang === "tw") {
        lang = "zh-CN";
      } else if (this.lang === "id") {
        lang = "id";
      } else {
        lang = "en-US";
      }
      const arr =
        (this.customServiceConfig.list || []).filter((v) => {
          return v.type === "customerService";
        }) || [];
      console.log(arr, "arr");
      if (arr.length === 0) return false;
      const content = JSON.parse(arr[0].content || "");
      var url = content.url; // 获取当前url
      if (!url) return false;
      if (content.brand === "2") {
        // 其他客服品牌
        this.src = url;
      } else {
        // MM客服
        var dz_url = url.split("#")[0]; // 获取#/之前的字符串
        var dz_urldata = url.split("#")[1]; // 获取#/之后的字符串
        if (this.getToken) {
          this.src =
            dz_url +
            "&customers=" +
            this.user.sid +
            "," +
            this.user.nickname +
            "," +
            lang +
            "#" +
            dz_urldata;
        } else {
          this.src = dz_url + "&customers=,," + lang + "#" + dz_urldata;
        }
      }
      // 新标签
      // window.open(this.src, "_blank", "width=620, height=584");
      // 客服打点
      this.$eventPost("customer_service", { eid: `101_27_0_1` });
      this.$eventPost("click", {
        eid: `101_27_0_1`,
        time: Date.now(),
      });
      if (isMobile()) {
        TelegramUtil.hideBackButton();
        window.open(this.src, "_self", "width=620, height=584");
      } else {
        window.open(this.src, "_blank", "width=620, height=584");
      }
    },
    vipKehubox() {
      if (!this.getToken) return false;
      this.user = this.$store.getters?.user || {};
      const userLevel = this.user.level || 0;
      const level = this.vipKefu.level || 0;
      if (userLevel < level) {
        this.visible = true;
        return false;
      }
      var url = this.vipKefu.url; // 获取当前url
      if (!url) return false;
      const vipUrl = url;
      // let lang = "";
      // if (this.lang === "pu") {
      //   lang = "pt-BR";
      // } else if (this.lang === "en") {
      //   lang = "en-US";
      // } else if (this.lang === "zh" || this.lang === "tw") {
      //   lang = "zh-CN";
      // } else if (this.lang === "id") {
      //   lang = "id";
      // } else {
      //   lang = "en-US";
      // }
      // var dz_url = url.split("#")[0]; // 获取#/之前的字符串
      // var dz_urldata = url.split("#")[1]; // 获取#/之后的字符串
      // const vipUrl =
      //   dz_url +
      //   "&customers=" +
      //   this.user.sid +
      //   "," +
      //   this.user.nickname +
      //   "," +
      //   lang +
      //   "#" +
      //   dz_urldata;
      // 客服打点
      this.$eventPost("customer_service", { eid: `101_27_0_1` });
      this.$eventPost("click", {
        eid: `101_27_0_1`,
        time: Date.now(),
      });
      if (isMobile()) {
        TelegramUtil.hideBackButton();
        window.open(vipUrl, "_self", "width=620, height=584");
      } else {
        window.open(vipUrl, "_blank", "width=620, height=584");
      }
    },
    handleClose() {
      this.visible = false;
    },
    handleRecharge() {
      this.handleClose();
      this.$Bus.$emit("showCharge", { show: true });
    },
  },
};
